import { useParams } from "react-router-dom";

import Documents from "./Documents";
import Main from "./Main";
import Loader from "../components/Loader";
import ToastComponent from "../components/ToastComponent";

import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import '../assets/scss/index.scss';

const Containers = () => {
    const { firstParam } = useParams();

    const Specified = firstParam && pages[firstParam] ? pages[firstParam] : Main;

    return (
        <>
            <Loader />
            <ToastComponent />
            <Specified />
        </>
    );
};

const pages = {
    documents: Documents,
};

export default Containers;
